module.exports = __webpack_public_path__ + "static/Nidhi-Prabhakar-Ghuman.ac9f671b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Nidhi-Prabhakar-Ghuman.jpg
// module id = 920
// module chunks = 146520050992020